// src/components/ClientPortalDashboard.js

import React from 'react';

function ClientPortalDashboard({ currentUser, clients, cases, documents, invoices, tasks, communicationLogs }) {
  // Find the specific client profile linked to the current user
  const clientProfile = (clients || []).find(client => client.user === currentUser.id);

  // Filter data relevant to this specific client profile
  const clientCases = (cases || []).filter(c => c.client === (clientProfile ? clientProfile.id : null));
  const clientDocuments = (documents || []).filter(d => d.client === (clientProfile ? clientProfile.id : null));
  const clientInvoices = (invoices || []).filter(i => i.client === (clientProfile ? clientProfile.id : null));
  const clientTasks = (tasks || []).filter(t => t.case && (clientCases || []).some(c => c.id === t.case)); // Tasks related to client's cases
  // eslint-disable-next-line no-unused-vars
  const clientCommunicationLogs = (communicationLogs || []).filter(log => log.client === (clientProfile ? clientProfile.id : null) || (log.case && (clientCases || []).some(c => c.id === log.case)));

  // Basic stats for the client dashboard
  const totalCases = clientCases.length;
  const openCases = clientCases.filter(c => c.status === 'OPEN' || c.status === 'ACTIVE').length;
  const totalDocuments = clientDocuments.length;
  const outstandingInvoices = clientInvoices.filter(i => i.status !== 'PAID' && i.status !== 'CANCELLED').length;
  const pendingTasks = clientTasks.filter(t => t.status === 'PENDING' || t.status === 'IN_PROGRESS').length;

  return (
    <div>
      <h2 className="text-2xl font-bold text-primary mb-1">Welcome, {currentUser.username}!</h2>
      {clientProfile ? (
        <p className="text-gray-500 mb-6">Your Client Profile: {clientProfile.first_name} {clientProfile.last_name}</p>
      ) : (
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
          <p className="text-yellow-700">Your user account is not yet linked to a client profile. Please contact the firm administrator.</p>
        </div>
      )}

      <h3 className="text-lg font-semibold text-gray-700 mb-4">Your Overview</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className="bg-primary rounded-lg shadow p-5 text-white">
          <div className="flex items-center gap-2 mb-2">
            <i className="bi bi-folder text-lg"></i>
            <span className="font-semibold">Your Cases</span>
          </div>
          <div className="text-3xl font-bold">{totalCases} <span className="text-base font-normal opacity-80">({openCases} Open)</span></div>
        </div>
        <div className="bg-success rounded-lg shadow p-5 text-white">
          <div className="flex items-center gap-2 mb-2">
            <i className="bi bi-file-earmark-text text-lg"></i>
            <span className="font-semibold">Your Documents</span>
          </div>
          <div className="text-3xl font-bold">{totalDocuments}</div>
        </div>
        <div className="bg-accent rounded-lg shadow p-5 text-white">
          <div className="flex items-center gap-2 mb-2">
            <i className="bi bi-receipt text-lg"></i>
            <span className="font-semibold">Outstanding Invoices</span>
          </div>
          <div className="text-3xl font-bold">{outstandingInvoices}</div>
        </div>
        <div className="bg-warning rounded-lg shadow p-5 text-white">
          <div className="flex items-center gap-2 mb-2">
            <i className="bi bi-check2-square text-lg"></i>
            <span className="font-semibold">Pending Tasks</span>
          </div>
          <div className="text-3xl font-bold">{pendingTasks}</div>
        </div>
      </div>

      <h3 className="text-lg font-semibold text-gray-700 mb-3">Recent Activity</h3>
      <div className="bg-white rounded-lg shadow border border-gray-200 p-5">
        <p className="text-gray-400">This section will show recent updates related to your cases, documents, and communications.</p>
      </div>
    </div>
  );
}

export default ClientPortalDashboard;
